import BrandLogo from './BrandLogo';
import { LogOut } from 'lucide-react';
import { useI18n, type Locale } from '../i18n';
import type { RegistrationAccessStatus } from '../lib/registerApi';
import RegistrationAccessNotice from './RegistrationAccessNotice';

export default function RegistrationWaitingPage({ status, error = false, onRetry, onLogout }: {
  status: RegistrationAccessStatus | null; error?: boolean; onRetry: () => void; onLogout: () => void;
}) {
  const { t, locale, setLocale } = useI18n();
  return <div className="flex min-h-screen flex-col bg-gray-50">
    <header className="flex min-h-16 items-center justify-between gap-4 border-b border-gray-200 bg-white px-4 sm:px-6">
      <BrandLogo imageClassName="h-10" />
      <div className="flex items-center gap-2">
        <select value={locale} onChange={event => setLocale(event.target.value as Locale)} aria-label={t('language')} className="min-h-11 rounded-md border border-gray-200 bg-white px-2 text-sm text-gray-700">
          <option value="nl">🇳🇱 NL</option><option value="en">🇬🇧 EN</option>
        </select>
        <button type="button" onClick={onLogout} aria-label={t('logout')} title={t('logout')} className="flex min-h-11 min-w-11 items-center justify-center rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50 focus-visible:outline-primary-500"><LogOut size={18} aria-hidden="true" /></button>
      </div>
    </header>
    <main className="flex flex-1 items-center justify-center px-4 py-8 sm:px-6">
      {status ? <RegistrationAccessNotice status={status} standalone />
        : <section role="status" className="w-full max-w-xl border-y border-gray-200 bg-white px-5 py-6 text-sm text-gray-600 sm:p-8">
          <p>{t(error ? 'register_access_check_failed' : 'common_loading')}</p>
          {error && <button type="button" onClick={onRetry} className="mt-3 min-h-11 font-medium text-gray-700 underline underline-offset-2">{t('dugout_access_requests_retry')}</button>}
        </section>}
    </main>
  </div>;
}
